import { Routes } from '@angular/router';
import { roleGuard, rootSystemAdminGuard } from '../../../lib/guards/admin-role.guard';
import { HOLIDAY_CALENDAR_CONFIG } from './base/holiday-calendar-config';

/**
 * 공휴일 캘린더 라우트 (계획서 2026-09-03 P4).
 *
 * <p>견적 템플릿 항목의 날짜 조건이 이 데이터를 참조한다. 기준정보 성격이라 견적 템플릿과 같은
 * {@code ADMIN_MASTER} 권한을 요구한다.
 */
export const holidayCalendarRoutes: Routes = [
  {
    path: HOLIDAY_CALENDAR_CONFIG.routePath!,
    canActivate: [roleGuard('ADMIN_MASTER'), rootSystemAdminGuard],
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/holiday-calendar-list-page/holiday-calendar-list-page.component'
          ).then((m) => m.HolidayCalendarListPageComponent),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/holiday-calendar-detail-page/holiday-calendar-detail-page.component'
              ).then((m) => m.HolidayCalendarDetailPageComponent),
          },
        ],
      },
    ],
  },
];
